import { render, staticRenderFns } from "./StatisticsContent.vue?vue&type=template&id=471fc890&scoped=true&"
import script from "./StatisticsContent.vue?vue&type=script&lang=js&"
export * from "./StatisticsContent.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsContent.vue?vue&type=style&index=0&id=471fc890&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471fc890",
  null
  
)

export default component.exports